(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Impegno', Impegno);

    Impegno.$inject = ['$resource', 'DateUtils'];

    function Impegno ($resource, DateUtils) {
        var resourceUrl =  'api/impegnos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
